import { cn } from "@/lib/utils";
import React from "react";
import { useCreateChannelWithGuest } from "@/components/pages/chats/hooks/useChannel";
import { useNavigate } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";

interface MessageGuestButtonProps {
  bookingId: string;
  className?: string;
}
export const MessageGuestButton = ({
  bookingId,
  className,
}: MessageGuestButtonProps) => {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useCreateChannelWithGuest();

  const handleMessageGuest = async (e: React.MouseEvent) => {
    e.stopPropagation();
    const channel = await mutateAsync(bookingId);
    if (!channel.id) {
      return;
    }
    navigate(`/chats?activeChannel=${encodeURIComponent(channel.id)}`);
  };

  return (
    <Button
      variant="new_ghost"
      onClick={handleMessageGuest}
      disabled={isPending}
      className={cn("relative cursor-pointer", className)}
    >
      <MessageSquare className={"text-indigo/50 h-4 w-4"} />
    </Button>
  );
};
